import React from 'react';
import PropTypes from 'prop-types';

import JobProfileConst from '../../../constant/JobProfileConst';

const isValueInRange = (value, low, high) => value >= low && value <= high;

const getRangeUI = (range, isShowNumber = false) => {
  const { low, high } = range;
  const { min, max } = JobProfileConst.DEFAULT_RANGE;
  const code = range.code ? range.code : range.id;

  const rangeUI = [];
  for (let i = min; i <= max; i += 1) {
    let className = '';
    if (isValueInRange(i, low, high)) {
      className += ' on';
    }

    rangeUI.push(
      <li className={className} key={`${code}-${i}`}>
        {isShowNumber && <span>{i}</span>}
      </li>,
    );
  }

  return rangeUI;
};

const DistortionDimensionRange = ({
  dimensionRange,
}) => {
  if (!dimensionRange) return null;

  const {
    displayName,
  } = dimensionRange;

  const dimensionRangeUI = dimensionRange ? getRangeUI(dimensionRange, true) : null;

  return (
    <div className="ability">
      <div className="ability-label">{displayName}</div>

      <div className="ability-body">
        {dimensionRangeUI && (
          <ul className="range">
            {dimensionRangeUI}
          </ul>
        )}
      </div>
    </div>
  );
};

DistortionDimensionRange.propTypes = {
  dimensionRange: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DistortionDimensionRange;
